export default "__VITE_ASSET__BYxfvrfI__"